import service from '@/api/assignments';
import {loading, alert, handleError} from '@/state/generators/helpers';

export const state = {
    loading: false,
    service: service('admin/doctor-patient-assignments'),
    item: {},
    errors: {}
};

export const getters = {
    loading: function (state) {
        return !!state.loading;
    },
    item: function (state) {
        return JSON.parse(JSON.stringify(state.item));
    },
    errors: function (state) {
        const errors = Object.assign({}, (state.errors || {}));

        Object.keys(errors).forEach(key => {
            errors[key] = errors[key].join(' ');
        });

        return errors;
    },
    states: function (state) {
        const states = {};

        Object.keys(state.errors || {}).forEach(key => {
            states[key] = false;
        });

        return states;
    }
};

export const mutations = {
    'SET_LOADING': function (state, boolean = true) {
        state.loading = boolean;
    },
    'SET_ITEM': function (state, item = {}) {
        state.item = item;
    },
    'SET_ERRORS': function (state, errors = {}) {
        state.errors = errors;
    }
};

export const actions = {
    create: function ({commit, state}, payload) {
        loading(commit);

        return state.service.store(payload).then(response => {
            commit('SET_ITEM', response);
            commit('SET_ERRORS', {});
            alert(commit, this.$t('request.creation_is_successful'));
            loading(commit, false);
            return response;
        }).catch((e) => {
            return handleError(e, commit);
        });
    },

    destroy: function ({commit, state}, id) {
        loading(commit);

        return state.service.destroy(id).then(response => {
            commit('SET_ITEM', {});
            alert(commit, this.$t('request.deletion_is_successful'));
            loading(commit, false);
            return response;
        }).catch((e) => {
            return handleError(e, commit);
        });
    },

    clearItem: function ({commit}) {
        commit('SET_ITEM', {});
    },

    clearErrors: function ({commit}) {
        commit('SET_ERRORS', {});
    }
};
